import TabelaEnderecoService from "./TabelaEnderecoService";
import TabelaMixin from "@/shared/mixin/TabelaMixin";

export default {
  mixins: [TabelaEnderecoService, TabelaMixin],
  props: {
    idRnpPrestador: {
      type: [String, Number]
    }
  },
  data() {
    return {
      objetoTabela: {
        pagina: 1,
        tamanho: 9,
        ordenacao: "",
        direcao: "ASC",
        idRnpPrestador: -1
      },
      usarStore: false,
      objetoModalEndereco: {},
      listaCidades: [],
      listaTipoEndereco: []
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loadingTabela = true;
      this.inicializarTipoEndereco().finally(() => {
        this.iniciarTabela();
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as linhas da tabela e outras informações adicionais
     */
    iniciarTabela() {
      this.loadingTabela = true;

      this.atualizarObjetoTabela({
        idRnpPrestador: this.idRnpPrestador
      });

      this.getTabelaEndereco(this.objetoTabelaComputed)
        .then(res => {
          this.configurarTabela(res.data, rows => {
            this.montarTabela(rows);
          });
        })
        .finally(() => {
          this.loadingTabela = false;
        });
    },
    /**
     * Método para montar a tabela
     *  @param {Array} rows - linhas da tabela
     */
    montarTabela(rows) {
      this.rows = [];
      this.rows = rows.map(e => {
        const { chaveReferencia, tipo, cnpj, bairro, cidade, uf, id } = e;

        return {
          tipo,
          documento: this.$helpers.formatarCampoCpfCnpj(cnpj),
          endereco: `${this.letraMaiusculaCadaPalavra(
            bairro
          )}, ${cidade} - ${uf}`,
          codigo: chaveReferencia,
          naoMostrar: {
            naoAparece: true,
            id
          }
        };
      });
    },
    pesquisarEndereco() {
      this.atualizarObjetoTabela({
        cnpjOrCodigoReferencia: this.campoPesquisa,
        pagina: 1
      });

      this.iniciarTabela();
    },
    abrirModalEndereco(index) {
      const { arquivo, nrSeq } = this.rows[index].naoMostrar.id;
      this.$store.commit("setLoadingModal", true);

      this.getDetalheEndereco(arquivo, nrSeq)
        .then(res => {
          let objetoEndereco = res.data;

          const {
            cnpj,
            dddTelefonePrincipal,
            dddTelefoneSecundario,
            dddFax,
            dddWhatsapp,
            telefonePrincipal,
            telefoneSecundario,
            fax,
            whatsapp,
            logradouro,
            bairro,
            cep
          } = objetoEndereco;

          objetoEndereco = {
            ...objetoEndereco,
            cnpj: this.$helpers.formatarCampoCpfCnpj(cnpj),
            dddTelefonePrincipal:
              dddTelefonePrincipal && dddTelefonePrincipal
                ? this.zeroEsquerda(dddTelefonePrincipal, 2)
                : " - ",
            dddTelefoneSecundario:
              dddTelefoneSecundario && dddTelefoneSecundario
                ? this.zeroEsquerda(dddTelefoneSecundario, 2)
                : " - ",
            dddFax: dddFax && dddFax ? this.zeroEsquerda(dddFax, 2) : " - ",
            dddWhatsapp: dddWhatsapp && dddWhatsapp ? dddWhatsapp : " - ",
            telefonePrincipal: dddTelefonePrincipal ? telefonePrincipal : "",
            telefoneSecundario: dddTelefoneSecundario ? telefoneSecundario : "",
            fax: dddFax ? fax : "",
            whatsapp: dddWhatsapp ? whatsapp : "",
            logradouro: this.letraMaiusculaCadaPalavra(logradouro),
            bairro: this.letraMaiusculaCadaPalavra(bairro),
            cep: this.mascaraCep(cep)
          };

          Object.entries(objetoEndereco).forEach(e => {
            objetoEndereco[e[0]] = e[1] ? e[1] : " - ";
          });

          this.objetoModalEndereco = objetoEndereco;
          this.mostrarModalEndereco = true;
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    limparPesquisa() {
      this.campoPesquisa = "";
    },
    inicializarTipoEndereco() {
      return new Promise((resolve, reject) => {
        this.getTipoEndereco()
          .then(res => {
            this.listaTipoEndereco = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    }
  },
  computed: {
    subtituloMensagemVazia() {
      const existeTabela = this.qtResultados > 0,
        existeCampoPesquisa = this.campoPesquisa.length > 0,
        existeFiltro = this.quantidadeFiltroNumero > 0;

      if (!existeTabela && (existeCampoPesquisa || existeFiltro))
        return "mostrar todos";

      return "";
    }
  }
};
